'use client'
import { useState } from 'react';
import tailwindConfig from '@tailwind.config'


const AmenitiesWithGroups = ({ features, dictionary, lang }) => {

    const style2 = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 160,
        overflow: 'hidden',
        z: 10
    };

    const [showFullContent, setShowFullContent] = useState(false);

    const toggleContent = () => {
        setShowFullContent(!showFullContent);
    };

    const categoryHasElements = {
        feature: false,
        utility: false,
        kitchen: false,
        location: false,
        communal: false
    };

    features.forEach(feature => {
        if (categoryHasElements.hasOwnProperty(feature.type)) {
            categoryHasElements[feature.type] = true;
        }
    });

    return (

        <>
        {!showFullContent ? (
            <>
                <div style={style2} className='mb-3 pb-3 '>
                    {categoryHasElements.feature && (
                        <h3 className='text-maincolor font-semibold text-xl'>{dictionary.keyfeatures}</h3>
                    )}
                    <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                        {features.map((feature, index) => {
                            if (feature.type == 'feature') {
                                return (
                                    <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                        <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                    {categoryHasElements.utility && (
                        <h3 className='text-maincolor font-semibold text-xl'>{dictionary.amenities}</h3>
                    )}
                    <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                        {features.map((feature, index) => {
                            if (feature.type == 'utility') {
                                return (
                                    <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                        <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                    {categoryHasElements.kitchen && (
                        <h3 className='text-maincolor font-semibold text-xl'>{dictionary.kitchen}</h3>
                    )}
                    <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                        {features.map((feature, index) => {
                            if (feature.type == 'kitchen') {
                                return (
                                    <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                        <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                    {categoryHasElements.location && (
                        <h3 className='text-maincolor font-semibold text-xl'>{dictionary.nearby}</h3>
                    )}
                    <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                        {features.map((feature, index) => {
                            if (feature.type == 'location') {
                                return (
                                    <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                        <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                    {categoryHasElements.communal && (
                        <h3 className='text-maincolor font-semibold text-xl'>{dictionary.development}</h3>
                    )}
                    <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                        {features.map((feature, index) => {
                            if (feature.type == 'communal') {
                                return (
                                    <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                        <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                </div>
                {!showFullContent && (
                    <div className='relative w-full flex flex-row-reverse'>
                        <div className='absolute right-0 left-0 top-[-20px] h-[20px] bg-gradient-to-b from-transparent to-light'></div>
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-full border-b-[1px]'></div>
                            <div className='w-[200px]'>
                                <button
                                    className="text-maincolor text-xl w-[200px] cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? `${dictionary.collapseAmenities}` : `${dictionary.expandAmenities}`}
                                </button>
                            </div>
                            <div className='w-full border-b-[1px]'></div>
                        </div>
                    </div>
                )}
            </>
        ) : (
            <div className='mb-3 pb-3'>
                {categoryHasElements.feature && (
                    <h3 className='text-maincolor font-semibold text-xl'>{dictionary.keyfeatures}</h3>
                )}
                <div className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                    {features.map((feature, index) => {
                        if (feature.type == 'feature') {
                            return (
                                <div key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                    <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                </div>
                            )
                        }
                    })}
                </div>
                {categoryHasElements.utility && (
                    <h3 className='text-maincolor font-semibold text-xl'>{dictionary.amenities}</h3>
                )}
                <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                    {features.map((feature, index) => {
                        if (feature.type == 'utility') {
                            return (
                                <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                    <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
                {categoryHasElements.kitchen && (
                    <h3 className='text-maincolor font-semibold text-xl'>{dictionary.kitchen}</h3>
                )}
                <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                    {features.map((feature, index) => {
                        if (feature.type == 'kitchen') {
                            return (
                                <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                    <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
                {categoryHasElements.location && (
                    <h3 className='text-maincolor font-semibold text-xl'>{dictionary.nearby}</h3>
                )}
                <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                    {features.map((feature, index) => {
                        if (feature.type == 'location') {
                            return (
                                <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                    <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
                {categoryHasElements.communal && (
                    <h3 className='text-maincolor font-semibold text-xl'>{dictionary.development}</h3>
                )}
                <ul className='flex flex-row flex-wrap justify-between text-xl mb-2'>
                    {features.map((feature, index) => {
                        if (feature.type == 'communal') {
                            return (
                                <li key={index} className='flex flex-row items-center justify-start w-1/2 mb-1'>
                                    <span className='ml-2 text-secondary'>{feature.amenityName?.[lang] ? feature.amenityName[lang] : feature.name}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
                {showFullContent && (
                    <div className='w-full flex flex-row items-center'>
                        <div className='w-full border-b-[1px]'></div>
                        <div className='w-[200px]'>
                            <button
                                className="text-maincolor text-xl w-[200px] cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light z-40"
                                onClick={toggleContent}
                            >
                                {showFullContent ? `${dictionary.collapseAmenities}` : `${dictionary.expandAmenities}`}
                            </button>
                        </div>
                        <div className='w-full border-b-[1px]'></div>
                    </div>
                )}
            </div>
        )}
        
        </>

    );
};

export default AmenitiesWithGroups;